export default [
    // 704, // lower_lateral__implant_crown_gingival_former
    // 705, // lower_lateral__implant_crown_titanium_abutment
    // 706, // lower_lateral__implant_crown_zirconium_abutment
    // 906,
    // 907,
    // 908,
    // 715,
    // 712,
    // 713,
    // 803,
    // 802,
    // 800,
    // 904,
    // 902,
    // 813
];
